"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var DeploymentContext;
(function (DeploymentContext) {
    DeploymentContext[DeploymentContext["development"] = 1] = "development";
    DeploymentContext[DeploymentContext["demo"] = 2] = "demo";
    DeploymentContext[DeploymentContext["staging"] = 3] = "staging";
    DeploymentContext[DeploymentContext["production"] = 4] = "production";
})(DeploymentContext || (DeploymentContext = {}));
var staticConfig = {
    domain: "unitview.eu.auth0.com",
    clientId: "a1P46dswlHcchaiAtMMZ6wvm9SIeUklu",
    audience: "https://api.unitview.co.uk",
    strapline: "The next generation of tenant services",
    googleMapsApiKey: "AIzaSyCCsIZ7E7pFdB1-yfAo34h422rgItR6gho" ////UV / AC google maps api key 
};
var currentContext = DeploymentContext.production;
function getContextDependantConfig() {
    if (currentContext === DeploymentContext.development) {
        return {
            deploymentContext: DeploymentContext.development,
            apiBaseUrl: "https://api.uv.co.uk",
            unitViewWebsiteUrl: "https://uv.co.uk",
            unitViewLogoUrl: "/img/uv_logo_dev.png"
        };
    }
    else if (currentContext === DeploymentContext.demo) {
        return {
            deploymentContext: DeploymentContext.demo,
            apiBaseUrl: "https://demo.api.unitview.co.uk",
            unitViewWebsiteUrl: "https://unitview.co.uk",
            unitViewLogoUrl: "/img/vue-logo.png" //TODO:TD make slick demo icon 
        };
    }
    else if (currentContext === DeploymentContext.staging) {
        return {
            deploymentContext: DeploymentContext.staging,
            apiBaseUrl: "https://api.theunitvue.co.uk",
            unitViewWebsiteUrl: "https://theunitvue.co.uk",
            unitViewLogoUrl: "/img/uv_logo_staging.png"
        };
    }
    else if (currentContext === DeploymentContext.production) {
        return {
            deploymentContext: DeploymentContext.production,
            apiBaseUrl: "https://api.unitview.co.uk",
            unitViewWebsiteUrl: "https://unitview.co.uk",
            unitViewLogoUrl: "/img/vue-logo.png" //TODO:TD make icon slicker
        };
    }
    else {
        throw new Error("currentContext not set");
    }
}
function getCurrentConfig() {
    return __assign(__assign({}, staticConfig), getContextDependantConfig());
}
exports["default"] = getCurrentConfig;
;
